type DeliveryType = 'in-person' | 'seller';

export interface IInfoFormValues {
  deliveryDate: string;
  deliveryType: DeliveryType | '';
  recipientName: string;
  city: string;
  state: string;
  address: string;
  plateNumber: number | null;
  postalCode: number | null;
}

export const infoInitialValues: IInfoFormValues = {
  deliveryDate: '',
  deliveryType: '',
  recipientName: '',
  city: '',
  state: '',
  address: '',
  plateNumber: null,
  postalCode: null,
};
